import { ModuleRoute } from 'partial/wrappers/ModuleWrapper';
import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from 'partial/Layout';
import ProfileWrapper from 'modules/auth/containers/ProfileWrapper';
import Logout from 'modules/auth/containers/Logout';
import { useRoutePermission } from 'modules/auth/hooks';

function Private() {
  const routes = useRoutePermission();

  return (
    <ProfileWrapper>
      <Routes>
        <Route exact path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/*" element={<Layout />}>
          {routes.map((route) =>
            route.subRoutes ? (
              <Route
                path={`${route.path}${route?.withNested ? '/*' : ''}`}
                key={route.path}
              >
                <Route
                  index
                  element={
                    <Navigate to={route?.subRoutes?.[0]?.path} replace />
                  }
                />
                {route.subRoutes.map(({ component, ...sub }) => (
                  <Route
                    key={JSON.stringify(sub)}
                    {...sub}
                    {...(sub?.path && {
                      path: `${sub?.path}${sub?.withNested ? '/*' : ''}`,
                    })}
                    element={
                      <ModuleRoute title={sub?.title} component={component} />
                    }
                  />
                ))}
              </Route>
            ) : (
              <Route
                path={`${route.path}${route?.withNested ? '/*' : ''}`}
                key={route.path}
                element={
                  <ModuleRoute title={route.path} component={route.component} />
                }
              />
            ),
          )}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Route>
      </Routes>
    </ProfileWrapper>
  );
}

export default Private;
